import { createAction } from 'redux-act';

export const fetchInformationList = createAction('fetch information-list');
export const failFetchInformationList = createAction('fail fetch information-list');
export const successFetchInformationList = createAction('success fetch information-list');



// WEBPACK FOOTER //
// ./src/actions/information.js